import React from 'react';
import { IconProps } from './types';

const AgencyOperationsIcon: React.FC<IconProps> = props => {
  const { width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4103 15.4246H20.0903"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.4103 20.9946H20.0903"
        stroke="#FCFCFD"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.4103 18.2146H20.0903"
        stroke="#FCFCFD"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.1303 20.9946H4.11028C3.99982 20.9946 3.91028 20.9051 3.91028 20.7946V3.2636C3.91028 3.13261 4.0341 3.03699 4.16083 3.0701L16.2008 6.2156C16.2889 6.23859 16.3503 6.31811 16.3503 6.4091V12.5946"
        stroke="#FCFCFD"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4103 15.4246H20.0903"
        stroke="#FCFCFD"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.67026 9.13452H6.97026C6.85981 9.13452 6.77026 9.22406 6.77026 9.33452V11.1445C6.77026 11.255 6.85981 11.3445 6.97026 11.3445H8.67026C8.78072 11.3445 8.87026 11.255 8.87026 11.1445V9.33452C8.87026 9.22406 8.78072 9.13452 8.67026 9.13452Z"
        fill="#FCFCFD"
      />
      <path
        d="M13.3003 9.13452H11.6003C11.4898 9.13452 11.4003 9.22406 11.4003 9.33452V11.1445C11.4003 11.255 11.4898 11.3445 11.6003 11.3445H13.3003C13.4107 11.3445 13.5003 11.255 13.5003 11.1445V9.33452C13.5003 9.22406 13.4107 9.13452 13.3003 9.13452Z"
        fill="#FCFCFD"
      />
      <path
        d="M8.67026 13.7947H6.97026C6.85981 13.7947 6.77026 13.8842 6.77026 13.9947V15.8047C6.77026 15.9151 6.85981 16.0047 6.97026 16.0047H8.67026C8.78072 16.0047 8.87026 15.9151 8.87026 15.8047V13.9947C8.87026 13.8842 8.78072 13.7947 8.67026 13.7947Z"
        fill="#FCFCFD"
      />
    </svg>
  );
};

export default AgencyOperationsIcon;
